<template>
  <div id="app">
    <b-container fluid>
      <b-row>
        <b-col>
          <div style="background-color: blue; margin-bottom: 10px;">
            <img src="https://progetto.esten.se/wp-content/uploads/2019/07/logo_piccolo-1.png" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div align="left" id="nav">
            <ul>
              <!-- <li v-bind:key="item.id" v-for="(item,index) in inventory"> -->
              <li v-bind:key="item.id" v-for="(item,index) in listItems">
                <a
                  href="#"
                  @click="open(index)"
                  :class="{'active': index == activeIndex}"
                >{{ item.label }}</a>&nbsp;
                <b-badge variant="dark">{{ item.count }}</b-badge>
              </li>
            </ul>
          </div>
        </b-col>
        <b-col cols="9">
          <div v-lazy-container="{ selector: 'img' }">
            <div class="object" v-bind:key="doc.id" v-for="doc in leafdocs.documents">
              <!-- <img v-lazy="'https://staging.esten.se/beu/'+doc.ariannaid+'.jpg'" /> -->

              <img
                height="250"
                v-bind:data-src="'https://beu-covers.s3.amazonaws.com/' + doc.ariannaid + '.jpg'"
              />

              <a v-bind:href="'https://staging.esten.se/beu/' +doc.id">{{ doc.signature }}</a>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import orderBy from "lodash.orderby";

export default {
  name: "app",
  data() {
    return { inventory: [], leafdocs: [], activeIndex: null };
  },
  created() {
    var self = this;
    axios
      .get(`./inventory.json`)
      .then(response => (self.inventory = response.data));
  },
  computed: {
    listItems() {
      return orderBy(this.inventory, "label", "asc");
    }
  },
  methods: {
    open: function(id) {
      this.activeIndex = id;
      this.leafdocs = this.listItems[id];
      // this.leafdocs = this.inventory[id];
    }
  }
};
</script>




<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

#nav {
  position: fixed;
}

.object {
  display: inline-block;
  width: 200px;
  height: 250px;
  margin: 2em;
}
.active {
  font-weight: bolder;
  text-decoration: underline;
}
</style>
